module.exports = __webpack_public_path__ + "img/F5gw4y1WkAEZQQx.6f7c2529.jpg";